import { Link, useLocation } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "/techsaathi-logo.png";

export default function SiteNav() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <header className="sticky top-0 z-50 h-16 sm:h-20 bg-white/90 backdrop-blur-md border-b border-slate-200/80 shadow-sm">
      <div className="max-w-7xl mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Link
          to="/"
          data-testid="lcost-nav-logo"
          className="flex items-center gap-2.5 shrink-0"
        >
          <img
            src={LOGO_URL}
            alt="TechSaathi"
            className="h-10 sm:h-12 w-auto select-none"
            draggable={false}
          />
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg sm:text-xl font-extrabold tracking-tight">
              <span className="text-[#1e429f]">Tech</span>
              <span className="text-[#0e9f6e]">Saathi</span>
            </span>
            <span className="hidden sm:block text-[11px] text-slate-500 mt-1">
              Technology ka har kadam, aapke saath.
            </span>
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          {!isAdmin && (
            <Link to="/sell" data-testid="lcost-nav-sell-btn">
              <Button
                size="sm"
                className="btn-brand text-white font-semibold rounded-full px-4 sm:px-5"
              >
                Sell your phone
              </Button>
            </Link>
          )}
          <Show when="signed-in">
            <Link
              to="/admin"
              data-testid="lcost-nav-admin-link"
              className="hidden sm:inline text-sm text-slate-600 hover:text-[#1a56db] font-medium px-2"
            >
              Admin
            </Link>
            <UserButton afterSignOutUrl="/" />
          </Show>
          <Show when="signed-out">
            {!isAdmin && (
              <Link
                to="/admin/sign-in"
                className="hidden sm:inline text-sm text-slate-500 hover:text-slate-900 font-medium px-2"
              >
                Admin
              </Link>
            )}
          </Show>
        </nav>
      </div>
    </header>
  );
}
